export const REVIEW_VITAL_TEST_FORM_FIELDS_NAMES = {
    ADD_FEEDACK: 'addFeedback',
}